import { decodeURLSearchParamsParam, encodeObjectToURLSearchParams, } from '@dossierhq/core';
import { useEffect } from 'react';
import { ChangelogStateActions, getQueryWithoutDefaults, initializeChangelogState, } from './ChangelogReducer.js';
export function initializeChangelogStateFromUrlQuery(urlSearchParams) {
    const actions = urlQueryToChangelogStateActions(urlSearchParams);
    return initializeChangelogState({ actions });
}
function urlQueryToChangelogStateActions(urlSearchParams) {
    const actions = [];
    if (urlSearchParams) {
        const query = decodeURLSearchParamsParam(urlSearchParams, 'query');
        const paging = decodeURLSearchParamsParam(urlSearchParams, 'paging');
        actions.push(new ChangelogStateActions.SetQuery(query ?? {}, {
            partial: false,
            resetPagingIfModifying: false,
        }));
        if (paging) {
            actions.push(new ChangelogStateActions.SetPaging(paging));
        }
    }
    return actions;
}
export function useSynchronizeUrlQueryAndChangelogState(urlSearchParams, onUrlSearchParamsChange, changelogState, dispatchChangelogState) {
    const { query, paging } = changelogState;
    useEffect(() => {
        if (!onUrlSearchParamsChange || !urlSearchParams)
            return;
        const params = {
            query: getQueryWithoutDefaults(query),
            paging,
        };
        const result = encodeObjectToURLSearchParams(params);
        if (urlSearchParams.toString() !== result.toString()) {
            onUrlSearchParamsChange(result);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [query, paging]);
    useEffect(() => {
        if (!urlSearchParams)
            return;
        const actions = urlQueryToChangelogStateActions(urlSearchParams);
        actions.forEach((action) => dispatchChangelogState(action));
    }, [dispatchChangelogState, urlSearchParams]);
    // useDebugLogChangedValues('useSynchronizeUrlQueryAndChangelogState', { query, paging, urlQuery });
}
//# sourceMappingURL=ChangelogUrlSynchronizer.js.map